export default "__VITE_ASSET__BcH9Ukes__"